import React from 'react';
import cn from 'classnames';
import type { IBaseElementProps } from '../BasicElement';
import Image, { IImage } from '../Image';
import Button, { ILink } from '../Button';
export interface IAlternatingTextAndImageItems {
	/**
	 * Image
	 */
	image?: IImage;
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Content
	 * @control richtext
	 */
	content?: string;
	/**
	 * Button link
	 */
	link?: ILink;
}

export interface IAlternatingTextAndImageProps extends IBaseElementProps {
	/**
	 * Heading
	 */
	heading?: string;
	contentRows?: IAlternatingTextAndImageItems[];
}

/**
 * Alternating Text And Image
 * @icon id
 * @block
 */

const AlternatingTextAndImage: React.FC<IAlternatingTextAndImageProps> = ({
	heading,
	contentRows = [],
	className,
	classNames = [],
}) => (
	<div className={className || cn('vhs-alternating-text-and-images', ...classNames)}>
		<div className="vhs-alternating-text-and-images__container">
			{heading && <h2 className="vhs-alternating-text-and-images__heading">{heading}</h2>}
			{contentRows.length > 0 &&
				<div className="vhs-alternating-text-and-images__wrapper">
					{contentRows.map(({ image, heading, content, link }, index) => (
						<div
							className={cn(
								'vhs-alternating-text-and-images__row row mx-0 mx-md-auto justify-content-center',
								index % 2 !== 0
									? 'flex-row-reverse justify-content-lg-between'
									: 'justify-content-lg-start',
							)}
							key={index}
						>
							<div className="vhs-alternating-text-and-images__image-wrapper">
								<Image {...image} className="vhs-alternating-text-and-images__image" />
							</div>
							<div className="vhs-alternating-text-and-images__content col-12 col-md">
								{heading && <h3 className="vhs-alternating-text-and-images__subheading">{heading}</h3>}
								{content && (
									<div
										className="vhs-alternating-text-and-images__text"
										dangerouslySetInnerHTML={{
											__html: content,
										}}
									/>
								)}
								{link && link.label && <Button {...link} className="vhs-alternating-text-and-images__button"  />}
							</div>
						</div>
					))}
				</div>
			}
		</div>
	</div>
);

export default AlternatingTextAndImage;
